export default {
  PROUNI_START: 'ProuniStart',
  PROUNI_NOT_ELIGIBLE: 'ProuniNotEligible',
  PROUNI_PERSONAL_DATA: 'ProuniPersonalData',
  PROUNI_PERSONAL_DOCUMENTS: 'ProuniPersonalDocuments',
  PROUNI_RESIDENCE: 'ProuniResidence',
  PROUNI_FAMILY_INCOME: 'ProuniFamilyIncome',
  PROUNI_EDUCATION: 'ProuniEducation',
  PROUNI_ACCEPTANCE: 'ProuniAcceptance',
  PROUNI_FOLLOW_UP: 'ProuniAcompanhamento',
};
